import { useEffect, useState } from 'react';

import { useTogglAccountContext } from '../../../../screens/ToggleAccountTokenProvider';
import { TogglTimeEntry } from '../../../../types/toggl-api';
import TimeEntriesLoader from '../time-entries-loader';

export function useTimeEntries(
  workspaceIds: number[],
  userId: number,
  start: string,
  stop: string
) {
  const { token } = useTogglAccountContext();
  const [timeEntries, setTimeEntries] = useState<TogglTimeEntry[]>([]);
  const [loader, setLoader] = useState<TimeEntriesLoader | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeEntries([]);
    setLoader(new TimeEntriesLoader(token, workspaceIds, userId, start, stop));
  }, [JSON.stringify(workspaceIds), start, stop]);

  useEffect(() => {
    void (async () => {
      if (loader) {
        setIsLoading(true);
        const result = await loader.next();
        if (!result.done && result.value !== undefined) {
          setTimeEntries((prev) => [...prev, ...result.value]);
        } else {
          setIsLoading(false);
        }
      }
    })();
  }, [timeEntries, loader]);

  return { timeEntries, isLoading };
}
